/**
 * Map of all Contentful marks.
 */
export enum MARKS {
  BOLD = 'bold',
  ITALIC = 'italic',
  UNDERLINE = 'underline',
  CODE = 'code',
  SUPERSCRIPT = 'superscript',
  SUBSCRIPT = 'subscript',
  STRIKETHROUGH = 'strikethrough',
}
